<template>
    <section content padding v-if="price.length > 0">
        <div class="d-block align-center">
            <h1 class="size-40">{{ $common.config.navigation[0].children.find(it => it.id === $route.query.id).name }}{{ $common.config.lang === 'cn' ? '定价' : 'Pricing' }}</h1>
            <br/>
            <p>
                <Button shape="circle" size="large" :type="month === 3 ? 'primary' : 'default'" @click="onMonth(3)"><span class="plr-md">3{{ $common.config.lang === 'cn' ? '个月' : 'Months' }}</span></Button>
                <Button shape="circle" size="large" :type="month === 12 ? 'primary' : 'default'" @click="onMonth(12)"><span class="plr-md">1{{ $common.config.lang === 'cn' ? '年' : 'Year' }}</span></Button>
            </p>
            <h3 class="d-flex justify-center mt-md" v-if="false">
                <a class="d-flex justify-start" @click="priceModal.show = true">{{ $common.config.lang === 'cn' ? '查看完整定价' : 'View All Prices' }}<Icon class="ml-xs" type="ios-help-circle-outline" size="24"/></a>
            </h3>
        </div>
        <br/>
        <Row>
            <Col :xs="24" :sm="12" :md="12" :lg="8" v-for="(item, index) in price" :key="index" v-if="price.length > 0">
                <div class="public-shell" padding margin border radius shadow>
                    <h1>{{ item.channel }} {{ $common.config.lang === 'cn' ? '通道' : 'Channel' }}</h1>
                    <h1 class="size-36 c-error">{{ $common.config.lang === 'cn' ? '￥' : '$' }} {{ item.price }}</h1>
                    <br/>
                    <p>{{ item.desc }}</p>
                    <br/>
                    <p>
                        <Button shape="circle" size="large" type="default">{{ $common.config.lang === 'cn' ? '立即订购' : 'Contact us' }}</Button>
                    </p>
                </div>
            </Col>
            <Col :xs="24" :sm="12" :md="12" :lg="8">
                <div class="public-shell" padding margin border radius shadow>
                    <h1>{{ $common.config.lang === 'cn' ? '私有部署' : 'On-premises deployment' }}</h1>
                    <h3 class="c-error" style="height: 52px;">{{ $common.config.lang === 'cn' ? '联系我们' : 'We will contact you shortly after you have submitted the form.' }}</h3>
                    <br/>
                    <br/>
                    <p>
                        <Button shape="circle" size="large" type="default" @click="toggleContact(1)">{{ $common.config.lang === 'cn' ? '提交需求' : 'Request price' }}</Button>
                    </p>
                </div>
            </Col>
        </Row>

        <Modal fullscreen v-model="priceModal.show" :footer-hide="true" title="完整定价">
            <h1 class="align-center">这是产品名称</h1>
        </Modal>
    </section>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                price: [],
                month: 3,
                priceModal: {
                    show: false,
                    title: '',
                    data: [],
                }
            }
        },
        async beforeDestroy() {
            await this.$bus.off('initPrice');
        },
        async mounted() {
            this.$bus.on('initPrice', async (data, com) => {
                if (!data || !com) return;
                this.price = [];
                await this.getPrice();
            });
        },
        methods: {
            async getPrice(){
                let res = await this.$api.getHttp('/product/price?id=' + this.$route.query.id + '&lang=' + this.$common.config.lang + '&month=' + this.month);
                console.log('this.getPrice---------->', res);
                this.price = [] = res.data.data;
            },
            async onMonth(data){
                console.log('this.onMonth---------->', data);
                this.month = data;
                this.getPrice();
            },
            async toggleContact(type){
                console.log('this.toggleContact---------->', type);
                this.$bus.emit('toggleContact', true, type);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Prices.vue